import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { OrganizationRole } from "../../common/models/organization-role";
import { AthleteGuest } from "../../common/models/athlete-guest";
import { User } from "../../common/models/user";
import { Guest } from "../../common/models/guest";
import { Athlete } from "../../common/models/athlete";
import { OrganizationMembership } from "../../common/models/organization-membership";

export class GuestRights {
    public Ready: Promise<boolean> = new Promise<boolean>((resolve, reject) => {});
    private _itemRightsList: GuestItemRightsList | null = null;
    private _screenRightsList: GuestScreenRightList | null = null;
    private _paramsItem: GuestItemRightsParams | null = null;
    private _paramsScreen: GuestScreenRightsParams | null = null;
    private _bestOfItemRight = 10000;
    private _bestOfScreenRight = 10000;
    constructor(private _utils: UtilsProvider) {
        this.setDefault();
    }

    public evaluateItemRight(params: GuestItemRightsParams): void {
        /**
         * Les paramètres reçus contiennent le guest, le user.id
         * et le organizationId. Les droits évalués doivent répondrent
         * à la question : qu'est-ce que je (user.id) peux faire avec
         * ce guest (guest.id) dans cette organisation (organizationId)
         * avec mon rôle (this._bestOfItemRight).
         */

        this._paramsItem = params;
        this.setDefault();
        this.setBestOfRole();

        const guest = this._paramsItem.guest;
        const memberships = this._utils.findManyIn([guest.userId], this._paramsItem.guestMemberships, 'userId');
        const orgIds = this._utils.getKeyValues(memberships, 'organizationId');

        if (!this._itemRightsList) return;

        switch (this._bestOfItemRight) {
            case OrganizationRole.ID_ADMIN:
                // this._paramsItem.user est un admin
                // tous les guests
                this._itemRightsList.view = true;
                this._itemRightsList.edit = true;
                this._itemRightsList.lock = true;
                this._itemRightsList.delete = true;
                this._itemRightsList.changeAthletes = true;
                this._itemRightsList.changeTeams = true;
                this._itemRightsList.sendInvitation = true;
                break;

            case OrganizationRole.ID_SUPERCOACH:
                // this._paramsItem.user est un supercoach
                // tous les guests de son organisation
                if (orgIds.indexOf(this._paramsItem.organizationId) > -1) {
                    this._itemRightsList.view = true;
                    this._itemRightsList.edit = true;
                    this._itemRightsList.lock = true;
                    this._itemRightsList.delete = true;
                    this._itemRightsList.changeAthletes = true;
                    this._itemRightsList.changeTeams = true;
                    this._itemRightsList.sendInvitation = true;
                }
                break;

            case OrganizationRole.ID_COACH:
                // this._paramsItem.user est un coach
                // uniquement son dashboard / profile
                // tous les guests de son organisation
                if (orgIds.indexOf(this._paramsItem.organizationId) > -1) {
                    this._itemRightsList.view = true;
                }
                break;

                /**
                 * L'athlète ne peut pas voir les guests :
                 * https://app.clickup.com/t/28ftvg
                 */
                // case OrganizationRole.ID_ATHLETE:
                //     // this._paramsItem.user est un athlète
                //     // voir le profil d'un de ses guest
                //     const relations = this._utils.findManyIn([guest.id], this._paramsItem.athleteGuestRelations, 'guestId');
                //     const athIds = this._utils.getKeyValues(relations, 'athleteId');
                //     const athletes = this._utils.findManyIn(athIds, this._paramsItem.athletes, 'id');
                //     const userIds = this._utils.getKeyValues(athletes, 'userId');
                //
                //     if (userIds.indexOf(this._paramsItem.user.id) > -1) {
                //         this._itemRightsList.view = true;
                //     }
                //     break;

            case OrganizationRole.ID_GUEST:
                // this._paramsItem.user est un invité
                // tous les guests de son organisation
                if (orgIds.indexOf(this._paramsItem.organizationId) > -1) {
                    this._itemRightsList.view = true;
                }
                // modifier uniquement son profil
                this._itemRightsList.edit = (guest.userId === this._paramsItem.user.id);
                break;

            default:
              // rien
        }
    }

    public evaluateScreenRights(params: GuestScreenRightsParams): void {

        /**
         * Détermine les droits que l'utilisateur possède
         * pour les commandes générales des écrans.
         */

        this._paramsScreen = params;
        this.setDefault();
        this.setBestOfRole();

        if (!this._screenRightsList) return;

        switch (this._bestOfScreenRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            this._screenRightsList.sendInvitation = true;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un super-coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            this._screenRightsList.sendInvitation = true;
            break;

        case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = false;
            this._screenRightsList.delete = false;
            break;

            /**
             * L'athlète ne peut pas voir les guests :
             * https://app.clickup.com/t/28ftvg
             */
            // case OrganizationRole.ID_ATHLETE:
            //     // this._paramsItem.user est un athlète
            //     this._screenRightsList.list = true;
            //     this._screenRightsList.add = false;
            //     this._screenRightsList.edit = false;
            //     this._screenRightsList.delete = false;
            //     break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            this._screenRightsList.list = true;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = false;
            break;

        default:
            // rien
        }
    }

    public getItemRightsList(): GuestItemRightsList {
      if (!this._itemRightsList) throw new Error('GuestRights.getItemRightsList: _itemRightsList is null');

      return this._itemRightsList;
    }

    public getScreenRightsList(): GuestScreenRightList {
        if (!this._screenRightsList) throw new Error('GuestRights.getScreenRightsList: _screenRightsList is null');

        return this._screenRightsList;
    }

    public getItemParams(): GuestItemRightsParams {
        if (!this._paramsItem) throw new Error('GuestRights.getItemParams: _paramsItem is null');

        return this._paramsItem;
    }

    public getScreenParams(): GuestScreenRightsParams {
        if (!this._paramsScreen) throw new Error('GuestRights.getScreenParams: _paramsScreen is null');

        return this._paramsScreen;
    }

    public get LIST() {
        if (this._screenRightsList) {
            return this._screenRightsList.list;
        }
        return false;
    }

    public get ADD() {
        if (this._screenRightsList) {
            return this._screenRightsList.add;
        }
        return false;
    }

    public get EDIT() {
        if (this._screenRightsList) {
            return this._screenRightsList.edit;
        }
        return false;
    }

    public get DELETE() {
        if (this._screenRightsList) {
            return this._screenRightsList.delete;
        }
        return false;
    }

    public get SEND_INVITATION() {
        if (this._screenRightsList){
            return this._screenRightsList.sendInvitation;
        }
        return false;
    }

    private setDefault(): void {

      this._itemRightsList = {
          view: false,
          edit: false,
          lock: false,
          delete: false,
          changeAthletes: false,
          changeTeams: false,
          sendInvitation: false,
        };

      this._screenRightsList = {
          list: false,
          add: false,
          edit: false,
          delete: false,
          sendInvitation: false,
        };

        this._bestOfItemRight = 10000;
        this._bestOfScreenRight = 10000;
    }

    private setBestOfRole() {

        if (this._paramsItem && this._paramsItem.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsItem.rolesIds.length; i++) {
                if (this._paramsItem.rolesIds[i] < this._bestOfItemRight) {
                    this._bestOfItemRight = this._paramsItem.rolesIds[i];
                }
            }
        }

        if (this._paramsScreen && this._paramsScreen.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsScreen.rolesIds.length; i++) {
                if (this._paramsScreen.rolesIds[i] < this._bestOfScreenRight) {
                    this._bestOfScreenRight = this._paramsScreen.rolesIds[i];
                }
            }
        }
    }
}

export interface GuestItemRightsList {
    view: boolean;
    edit: boolean;
    lock: boolean;
    delete: boolean;
    changeAthletes: boolean;
    changeTeams: boolean;
    sendInvitation: boolean;
}

const defaultRights: GuestItemRightsList = {
    view: false,
    edit: false,
    lock: false,
    delete: false,
    changeAthletes: false,
    changeTeams: false,
    sendInvitation: false,
};

export function mapUserRightsToGuestRights(userRights: string []): GuestItemRightsList {
  const rights = { ...defaultRights };

  userRights.forEach((right: string) => {
    if (right in rights) {
      rights[right as keyof GuestItemRightsList] = true;
    }
  });

  return rights;
}

export interface GuestScreenRightList {
    list: boolean;
    add: boolean;
    edit: boolean;
    delete: boolean;
    sendInvitation: boolean;
}

export interface GuestItemRightsParams {
    user: User;
    organizationId: number;
    guest: Guest;
    rolesIds: number[];
    athleteGuestRelations: AthleteGuest[];
    guestMemberships: OrganizationMembership[];
    athletes: Athlete[];
}

export interface GuestScreenRightsParams {
    rolesIds: number[];
}
